import { actionItem } from '../jsonEditor/actionItemJsonEditorConfig.js';
import { versionConfig, statusConfig, regionConfig, languageConfig } from '../options.js';
export const actionItems = {
    type: 'action-items',
    contentType: 'actionItem',
    editor: 'json',
    editorTitle: { name: 'title', placeholder: 'title' },
    editorConfig: actionItem,
    editorContext: 'root',
    supportContent: ['articles', 'milestones'],
    title: 'Action Item',
    plural: 'Action Items',
    endpoint: 'actionItems',
    queryProperties: [
        'id',
        'title',
        'slug',
        'status',
        'created',
        'modified',
        'client',
        'region',
        'language',
        'categories',
        'actionItemCategories',
    ],
    version: versionConfig,
    listing: {
        type: 'grid',
        gridColumns: ['title'],
        gridCombineProperty: 'slug',
        gridContentType: 'action-items',
        gridDecode: ['title'],
        gridFilters: [
            {
                label: 'Status',
                key: 'status',
                uppercase: false,
                default: false,
                value: 'published',
                options: statusConfig.options,
            },
            {
                label: 'Region',
                key: 'region',
                uppercase: false,
                default: true,
                options: regionConfig.options,
            },
            {
                label: 'Language',
                key: 'language',
                uppercase: false,
                default: true,
                options: languageConfig.options,
            },
        ],
        gridHasChildren: true,
        gridJoin: { properties: [] },
        gridSearch: [{ key: 'title', combine: true }],
        gridSupportContent: [],
    },
    sidebar: {
        status: [
            {
                label: 'Status',
                name: 'status',
                input: 'select',
                options: [
                    { label: 'Draft', value: 'draft' },
                    { label: 'Pending', value: 'pending' },
                    { label: 'Publish', value: 'published' },
                ],
            },
            {
                label: 'Created',
                name: 'created',
                input: 'datetime-local',
            },
        ],
        version: [
            { label: 'Slug', name: 'slug', input: 'text' },
            { label: 'Client', name: 'client', input: 'multiselect' },
            regionConfig,
            languageConfig,
        ],
        versioned: true,
        category: [
            { label: 'Categories', name: 'categories', type: 'category' },
            { label: 'Action Item Categories', name: 'actionItemCategories', type: 'actionItem' },
        ],
    },
    meta: [
        {
            label: 'Legacy ID',
            name: '_legacyId',
            input: 'number',
            description: 'Legacy ID for the document (if applicable).',
        },
        {
            label: 'Services Only',
            name: 'servicesOnly',
            input: 'select',
            description: 'Controls if this content should be hidden from the Aimee Hub front-end.',
            options: [
                { label: 'False', value: false },
                { label: 'True', value: true },
            ],
        },
    ],
    validate: [],
};
//# sourceMappingURL=actionItems.js.map